import gql from 'graphql-tag';

export const CREATE_PLACE_MUTATION = gql`
  mutation CreatePlace($input: CreatePlaceInput!) {
    createPlace(input: $input) {
      place {
        id
      }
    }
  }
`;
